import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonService, UserService } from '../../_services';
// import { BsModalRef, BsModalService } from 'ngx-bootstrap';
// import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal'

import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { ChangePasswordModalComponent } from './change-password-modal/change-password-modal.component';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';


@Component({
	selector: 'app-header',
	templateUrl: './app-header.component.html',
	styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent implements OnInit, OnDestroy {
	menu: { isMini: boolean } = { isMini: false };
	userInfo: any = {};
	isOpen = false;

	subscription!: Subscription;
	bsModalRef?: MatDialog;
	dialogRef?: MatDialogRef<any>;

	bsChangePasswordModalRef?: MatDialog;
	userMenu!: any;

	constructor(
		private router: Router,
		private coreService: CommonService,
		private userService: UserService,
		private dialog: MatDialog
		// private modalService: BsModalService
	) {
		this.router.events.subscribe((event) => {

			if (event instanceof NavigationStart) {
				if (this.dialog) {
					this.dialog.closeAll();
				}

				if (this.bsChangePasswordModalRef) {
					this.bsChangePasswordModalRef.closeAll();
				}
			}
		});
	}

	ngOnInit() {
		this.userInfo = this.userService.getUserInfo();
		// console.log("this.userInfo",this.userInfo)
		this.subscription = this.userService.getUserData.subscribe((value: any) => (this.userInfo = value));
		this.menu = this.coreService.menu;
	}

	logout() {
		this.userService.clearUserData();
		this.coreService.navigateTo('');
	}

	closeNotifications(event: any): void {
		const target = event.target as HTMLElement;

		if (
			!target.className.includes('btn-notification') &&
			!target.className.includes('ic-notification') &&
			!target.className.includes('notification-active')
		) {
			this.isOpen = false;
		}
	}


	toggleMenu() {
		this.menu.isMini = !this.menu.isMini;
		if (this.menu.isMini) {
			document.body.className = document.body.className.concat(' mini');
		} else {
			document.body.className = document.body.className.replace(' mini', '');
		}
	}

	editProfile() {
		
		const profilepopup = this.dialog.open(EditProfileComponent, {
			width: '400px',
			disableClose: true,
			panelClass: 'custom-modal'
		});

		profilepopup.afterClosed().subscribe((res: any) => {
			if (res && res.success) {
				this.coreService.showSuccess('', res.message);
			} else if (res) {
				this.coreService.showError('', res.message);
			}
		});

	}
	

	changePassword() {
		const dialogRef = this.dialog.open(ChangePasswordModalComponent, {
			disableClose: true, // prevents closing on backdrop click
			panelClass: 'custom-modal' // Use custom class for width/styling
		});

		dialogRef.afterClosed().subscribe((res: any) => {
			if (res && res.success) {
				this.coreService.showSuccess('', res.message);
			} else if (res) {
				this.coreService.showError('', res.message);
			}
		});
	}

	ngOnDestroy() {
		if (this.dialogRef) {
			this.dialogRef.close(); // ✅ no more warning
		}

		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}


	


}
